function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { FormHelper, i18n } from 'invision-core';
import CustomerCareLocaleKeys from '../../../../locales/keys';
import { updateSubscriberTreatment } from '../../../../reducers/actions/customer.convergent.biller.actions';
import { UpdateSubscriberTreatmentErrorSelector } from '../../../../reducers/selectors/customer.convergent.biller.selectors';
import { NOTIFICATION_TIME_LENGTH } from '../../../../customercare.constants';
import moment from 'moment';
var ESCALATE = '1';
var DEESCALATE = '2';
var ChangeStepPopupController = /*#__PURE__*/function () {
  function ChangeStepPopupController($ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, ChangeStepPopupController);
    this.$ngRedux = $ngRedux;
    this.$timeout = $timeout;
    this.uiNotificationService = uiNotificationService;
    this.ESCALATE = ESCALATE;
    this.DEESCALATE = DEESCALATE;
  }
  return _createClass(ChangeStepPopupController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          lastAttemptError: UpdateSubscriberTreatmentErrorSelector(store)
        };
      };
      var controllerActions = {
        updateSubscriberTreatment: updateSubscriberTreatment
      };
      this.resetForm();
      this.showForm = false;
      this.defaultDate = moment().add(1, 'days').startOf('day').toDate();
      this.todaysDate = new Date();
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.CustomerCareLocaleKeys = CustomerCareLocaleKeys;
      this.changeStepCallback = this.onChangeStep() || angular.noop;
      var onRegisterApi = this.config.onRegisterApi;
      this.config.onRegisterApi = function (_ref) {
        var api = _ref.api;
        _this.popupApi = Object.assign({}, api, {
          open: function open() {
            _this.resetForm();
            _this.showForm = true;
            _this.$timeout(function () {
              api.open();
            });
          }
        });
        onRegisterApi && onRegisterApi({
          api: _this.popupApi
        });
      };
      this.fieldErrorLookup = {
        TreatmentChangeStepDeescalationDate: {
          'invalidDate': i18n.translate(CustomerCareLocaleKeys.TREATMENT_DETAILS.CREATE_PROMISE_TO_PAY.ERRORS.START_DATE_INVALID),
          'minDate': i18n.translate(CustomerCareLocaleKeys.TREATMENT_DETAILS.CREATE_PROMISE_TO_PAY.ERRORS.START_DATE_IN_PAST)
        }
      };
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "closePopup",
    value: function closePopup() {
      this.popupApi.close();
      this.showForm = false;
    }
  }, {
    key: "handleSubmitForm",
    value: function handleSubmitForm() {
      var _this2 = this;
      if (!this.checkForErrors()) {
        this.actions.updateSubscriberTreatment(this.customerId, this.treatmentChangeStepEscalate, this.treatmentChangeStepDeescalationDate).then(function () {
          _this2.changeStepCallback(_this2.treatmentChangeStepEscalate === ESCALATE);
          _this2.uiNotificationService.success(i18n.translate(CustomerCareLocaleKeys.TREATMENT_DETAILS.CHANGE_STEP.SUCCESS_UPDATE), null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
          _this2.closePopup();
        }, function () {
          if (_this2.state.lastAttemptError && _this2.state.lastAttemptError.message) {
            _this2.serviceError = _this2.state.lastAttemptError.message;
          }
        });
      }
    }
  }, {
    key: "checkForErrors",
    value: function checkForErrors() {
      this.serviceError = null;
      this.formErrors = FormHelper.formHasErrors(this.formApi.$error, this.fieldErrorLookup);
      return this.formErrors.length > 0;
    }
  }, {
    key: "resetForm",
    value: function resetForm() {
      // set the default value for escalate.
      this.setDefaultEscalation();
      this.setDeescalationValue();
      this.onChangeEscalation();
      this.serviceError = null;
      this.formErrors = [];
    }
  }, {
    key: "onChangeEscalation",
    value: function onChangeEscalation() {
      this.isEscalateSelected = this.treatmentChangeStepEscalate === ESCALATE;
    }
  }, {
    key: "setDeescalationValue",
    value: function setDeescalationValue() {
      this.treatmentChangeStepDeescalationDate = this.defaultDate;
    }
  }, {
    key: "setDefaultEscalation",
    value: function setDefaultEscalation() {
      this.treatmentChangeStepEscalate = this.treatmentNextStepNumber ? ESCALATE : DEESCALATE;
    }
  }]);
}();
export default {
  template: require('./change.step.popup.html'),
  bindings: {
    config: '<',
    treatmentNextStepName: '<',
    treatmentNextStepNumber: '<',
    customerId: '<',
    treatmentEntryDate: '<',
    treatmentNextStepDate: '<',
    onChangeStep: '&'
  },
  controllerAs: 'ChangeStepPopup',
  controller: ChangeStepPopupController
};